/* 30/09 perf : ce fichier est chargé en « async » (il ne bloque plus l'affichage de la page).
   Il attend son repère #almk-drawer (posé juste avant la balise script) pour démarrer exactement au même moment qu'avant.
   Sans repère sur la page : il démarre à la fin du chargement. */
(function almBoot(){
  if (document.readyState === 'loading' && !document.getElementById('almk-drawer')) { setTimeout(almBoot, 20); return; }

(function () {
  'use strict';
  /* Interrupteur de secours ?nodrawer=1 — detection sans expression reguliere */
  var qs = location.search || '';
  if (qs.indexOf('nodrawer=1') > -1) return;

  var drawer = document.getElementById('ntydDrawer');
  var overlay = document.getElementById('ntydOverlay');
  if (!drawer || !overlay) return;

  document.documentElement.classList.add('ntyd-on');

  var burger = document.getElementById('mzBurger');
  var visual = document.getElementById('ntydVisual');
  var desktopMq = window.matchMedia('(min-width: 1001px)');
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var isOpen = false;
  var hideTimer = null;
  var visContext = 'default';

  if (burger) {
    burger.setAttribute('aria-controls', 'ntydDrawer');
    burger.setAttribute('aria-expanded', 'false');
  }

  function setBurger(open) {
    if (!burger) return;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.classList.toggle('active', open);
  }

  function rootPanel() { return drawer.querySelector('.ntyd-panel--root'); }

  /* ===== Volet visuel ===== */
  function setVis(key) {
    if (!visual) return;
    var target = visual.querySelector('.ntyd-fig[data-fig="' + key + '"]');
    if (!target) { target = visual.querySelector('.ntyd-fig[data-fig="default"]'); }
    if (!target || target.classList.contains('is-on')) return;
    visual.querySelectorAll('.ntyd-fig.is-on').forEach(function (f) { f.classList.remove('is-on'); });
    target.classList.add('is-on');
  }

  drawer.addEventListener('mouseover', function (e) {
    if (!desktopMq.matches) return;
    var t = e.target.closest && e.target.closest('[data-vis]');
    if (t) setVis(t.getAttribute('data-vis'));
  });
  var vp = drawer.querySelector('.ntyd-viewport');
  if (vp) {
    vp.addEventListener('mouseleave', function () {
      if (desktopMq.matches) setVis(visContext);
    });
  }

  /* Parallaxe douce du volet visuel */
  if (visual) {
    var rafPending = false;
    visual.addEventListener('pointermove', function (e) {
      if (!desktopMq.matches || reduceMq.matches || rafPending) return;
      rafPending = true;
      var x = e.clientX, y = e.clientY;
      window.requestAnimationFrame(function () {
        rafPending = false;
        var r = visual.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var nx = ((x - r.left) / r.width - 0.5) * -14;
        var ny = ((y - r.top) / r.height - 0.5) * -10;
        visual.style.setProperty('--ntx', nx.toFixed(2));
        visual.style.setProperty('--nty', ny.toFixed(2));
      });
    });
    visual.addEventListener('pointerleave', function () {
      visual.style.setProperty('--ntx', '0');
      visual.style.setProperty('--nty', '0');
    });
  }

  /* ===== Panneaux ===== */
  function resetPanels() {
    drawer.querySelectorAll('.ntyd-panel--sub').forEach(function (p) {
      p.classList.remove('is-active');
      p.setAttribute('aria-hidden', 'true');
    });
    drawer.querySelectorAll('[data-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    var r = rootPanel();
    if (r) r.removeAttribute('inert');
    drawer.classList.remove('is-sub');
    visContext = 'default';
  }

  function openDrawer() {
    /* 12/09 : images en lazy dans un conteneur hidden -> on force leur chargement a l'ouverture */
    try { drawer.querySelectorAll('img[loading="lazy"]:not(.ntyd-fig__img)').forEach(function (im) { im.loading = 'eager'; }); } catch (e) {}
    if (isOpen) return;
    isOpen = true;
    clearTimeout(hideTimer);
    drawer.hidden = false;
    overlay.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setBurger(true);
    setVis('default');
    var c = document.getElementById('ntydClose');
    if (c) c.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setBurger(false);
    hideTimer = setTimeout(function () {
      drawer.hidden = true;
      overlay.hidden = true;
      resetPanels();
    }, 560);
    if (burger) burger.focus({ preventScroll: true });
  }

  function openSub(id, trigger) {
    var p = drawer.querySelector('.ntyd-panel--sub[data-panel="' + id + '"]');
    if (!p) return;
    p.classList.add('is-active');
    p.removeAttribute('aria-hidden');
    p.scrollTop = 0;
    drawer.classList.add('is-sub');
    var r = rootPanel();
    if (r) r.setAttribute('inert', '');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    visContext = id;
    if (desktopMq.matches) setVis(id);
    var b = p.querySelector('.ntyd-back');
    if (b) b.focus({ preventScroll: true });
  }

  function goBack() {
    resetPanels();
    if (desktopMq.matches) setVis('default');
    var first = drawer.querySelector('[data-open]');
    if (first) first.focus({ preventScroll: true });
  }

  /* Interception du burger AVANT les listeners de l'ancien header (phase de capture) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#mzBurger');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (isOpen) { closeDrawer(); } else { openDrawer(); }
  }, true);

  drawer.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openSub(o.getAttribute('data-open'), o); return; }
    var back = e.target.closest('[data-back]');
    if (back) { e.preventDefault(); goBack(); return; }
    var c = e.target.closest('#ntydClose');
    if (c) { e.preventDefault(); closeDrawer(); }
  });

  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      if (drawer.classList.contains('is-sub')) { goBack(); } else { closeDrawer(); }
      return;
    }
    if (e.key === 'Tab') {
      var scope = drawer.classList.contains('is-sub')
        ? drawer.querySelectorAll('.ntyd-head a[href], .ntyd-head button, .ntyd-panel--sub.is-active a[href], .ntyd-panel--sub.is-active button, .ntyd-foot a[href]')
        : drawer.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled])');
      var focusables = Array.prototype.filter.call(scope, function (el) {
        return el.offsetParent !== null;
      });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();

})();
